import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import type { OverlayState } from "Interfaces";

const initialState: OverlayState = {
	enableOverlays: false,
	bannerOverlay: {
		enableOverlay: false,
		bannerMode: "Single",
		files: [
			{ file: null, location: "Bottom" },
			{ file: null, location: "Top" }
		],
		bannerSequenceTime: 5,
		sequenceLocation: "Bottom",
		enableFlash: false,
		flashOn: 2,
		flashOff: 1,
		displayMode: "Event",
		eventTypes: new Set([ "Motion", "Alarm In", "Analytics" ])
	},
	logoMotionOverlay: {
		enabled: false,
		file: null,
		displayMode: "logo",
		eventTypes: new Set([ "Motion", "Analytics" ])
	},
	logoAlarmOverlay: {
		enableOverlay: false,
		displayMode: "Show Logo on Alarm",
		file: null
	},
	borderOverlay: {
		enableOverlay: false,
		borderColor: "Red",
		borderWeight: 3,
		enableFlash: false,
		flashOn: 2,
		flashOff: 1,
		displayMode: "Event",
		eventTypes: new Set([ "Motion", "Alarm In", "Analytics" ])
	}
};

const setOverlaysReducer = (state: OverlayState, action: PayloadAction<OverlayState>) => {
	return action.payload;
};

const getOverlays = (state: OverlayState) => {
	return state;
};

const overlaySlice = createAppSlice({
	name: "overlays",
	initialState,
	reducers: {
		setOverlaysAction: setOverlaysReducer
	},
	selectors: {
		selectOverlays: getOverlays
	}
});

export default overlaySlice;

export const { setOverlaysAction } = overlaySlice.actions;
export const { selectOverlays } = overlaySlice.selectors;
